var testimonialsEnabled = false;
const allTestimonialSliders = document.querySelectorAll('.testimonial-slider');
function initTestimonialSlider() {
for( i=0; i< allTestimonialSliders.length; i++ ) {
  allTestimonialSliders[i].classList.add('swiper-testimonial-' + i);
  var slider = new Swiper('.swiper-testimonial-' + i, {
    slidesPerView: 1.2,
    rewind: true,
    pagination: {
      el: '.swiper-pagination-testimonial',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.next-slide-testimonial',
      prevEl: '.prev-slide-testimonial',
    }
  });
}
}

if (window.innerWidth <= 989) {
    initTestimonialSlider();
    testimonialsEnabled = true;
}

window.addEventListener('resize', function() {
    if (window.innerWidth <= 989 && testimonialsEnabled == false) {
        initTestimonialSlider();
        testimonialsEnabled = true;
    }
    else if (window.innerWidth >= 990 && testimonialsEnabled == true) {
        for(i=0; i< allTestimonialSliders.length; i++) {
            allTestimonialSliders[i].swiper.destroy();
        }
        testimonialsEnabled = false;
    }
});